module.exports = __webpack_public_path__ + "img/prykarpattyaoblenergo_presentation.c0a7f884.webp";